import React, { useEffect, useState } from 'react';
import { CheckCircle, Clock, XCircle } from '@phosphor-icons/react/ssr';
import { api } from './services/apiClient';

const planLabels = { basic: 'Básico', enterprise: 'Empresarial', trial: 'Prueba gratuita' };

const BillingSuccessPage = () => {
  const params        = new URLSearchParams(window.location.search);
  const transactionId = params.get('id')    ?? '';
  const planName      = params.get('plan')  ?? '';
  const billingCycle  = params.get('cycle') ?? 'monthly';

  const [status, setStatus] = useState('confirming'); // confirming | activated | pending | error
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (!transactionId) { setStatus('error'); setErrorMsg('No se recibió ID de transacción.'); return; }

    api.post('/api/billing/confirm', { transactionId, planName, billingCycle })
      .then(data => setStatus(data.activated ? 'activated' : 'pending'))
      .catch(err => {
        // 502: Wompi no respondió → mostrar pendiente (pago recibido, activación asíncrona)
        // Cualquier otro error: mostrar error con detalle
        if (err.message?.includes('verificar la transacción')) {
          setStatus('pending');
        } else {
          setStatus('error');
          setErrorMsg(err.message || 'Error desconocido.');
        }
      });
  }, [transactionId, planName, billingCycle]);

  const goToBilling = () => { window.location.href = '/?view=billing'; };

  const planLabel = planLabels[planName] ?? planName;

  const states = {
    confirming: {
      icon: <Clock size={64} weight="fill" style={{ color: 'var(--primary, #3b82f6)' }} />,
      title: 'Verificando tu pago…',
      message: 'Estamos confirmando el estado con Wompi, un momento.',
      showButton: false,
    },
    activated: {
      icon: <CheckCircle size={64} weight="fill" style={{ color: 'var(--success, #22c55e)' }} />,
      title: '¡Plan activado!',
      message: `Tu plan ${planLabel} quedó activo. Ya puedes usar todas sus funciones.`,
      showButton: true,
    },
    pending: {
      icon: <Clock size={64} weight="fill" style={{ color: 'var(--warning, #f59e0b)' }} />,
      title: 'Pago en proceso',
      message: 'Tu pago fue recibido. El plan se activará automáticamente una vez Wompi confirme la transacción (puede tardar unos minutos).',
      showButton: true,
    },
    error: {
      icon: <XCircle size={64} weight="fill" style={{ color: 'var(--danger, #ef4444)' }} />,
      title: 'No pudimos verificar el pago',
      message: errorMsg || 'Si realizaste el pago, el plan se activará cuando Wompi confirme la transacción.',
      showButton: true,
    },
  };

  const current = states[status];

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg, #f1f5f9)'
    }}>
      <div style={{
        width: '100%',
        maxWidth: 440,
        background: '#fff',
        borderRadius: 12,
        padding: '48px 40px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.1)',
        border: '1px solid #e5e7eb',
        textAlign: 'center'
      }}>
        <div style={{ marginBottom: 20 }}>{current.icon}</div>

        <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text-primary, #111827)', marginBottom: 10 }}>
          {current.title}
        </h1>

        <p style={{ fontSize: 15, color: 'var(--text-secondary, #6b7280)', marginBottom: 16, lineHeight: 1.6 }}>
          {current.message}
        </p>

        {transactionId && (
          <p style={{ fontSize: 12, color: 'var(--text-muted, #9ca3af)', marginBottom: 32, fontFamily: 'monospace' }}>
            Ref: {transactionId}
          </p>
        )}

        {current.showButton && (
          <button
            onClick={goToBilling}
            style={{
              width: '100%',
              padding: '10px 0',
              background: 'var(--primary, #3b82f6)',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontSize: 15,
              fontWeight: 600,
              cursor: 'pointer'
            }}
          >
            Ver mi plan
          </button>
        )}
      </div>
    </div>
  );
};

export default BillingSuccessPage;
